{
  "title": "如何預約活動接駁車",
  "description": "在活動頁預約免費接駁車座位，可用 Email 免建帳號，也可登入預約，並取得乘車 QR。",
  "headings": [
    "你會完成什麼",
    "適用角色",
    "操作前確認",
    "操作步驟",
    "完成後",
    "常見問題"
  ],
  "summary": "完成後，您會有一個已確認（或候補）的接駁座位，並在「我的接駁車」取得乘車 QR；上車時向工作人員出示即可。",
  "roleNote": "活動參與者（貴賓、教授、學生、合作夥伴皆可）；不需要是競賽參賽者",
  "prerequisites": [
    "知道活動網址，例如 /events/taai-2026，或由主導覽「活動」進入",
    "一個可收信的 Email（免登入預約）或已驗證 Email 的帳號（登入預約）",
    "每個方向每天只能有一筆預約，請先決定日期、去程或返程與班次"
  ],
  "pathLabel": "主導覽 → 活動 → 選擇活動 → 免費接駁車線上預約（/events/:slug/shuttle）",
  "steps": [
    {
      "title": "1. 開啟預約頁並看懂班次",
      "description": "在活動頁最上方按「免費接駁車線上預約」。預約頁會依服務日期分頁，預設顯示台北時間的今天，時間一律標示「台灣時間 (UTC+08:00)」。每張班次卡顯示班次代碼、出發與到達兩站，以及座位狀態（尚有座位、座位不多、已額滿可候補、尚未開放）。班次代碼像高鐵車次：三位數字依序是日期（1 = 11/20，2 = 11/21）、出發站、到達站；站別 1 = 臺北大學站，2 = 板橋高鐵站，3 = 會場。例如 113 是第一天臺北大學站往會場。可用頁內「中文／English」切換語言。"
    },
    {
      "title": "2. 選擇預約方式",
      "description": "已登入且 Email 已驗證：直接按班次的「預約座位」。尚未登入：可按「只用 Email 預約（免建立帳號）」，填寫真實姓名與 Email，勾選「我確認這是我的真實姓名」，完成驗證後按「寄給我確認連結」。也可用 Google 一鍵登入，登入後會回到原頁。免登入預約在您開啟 Email 連結之前不會保留座位。"
    },
    {
      "title": "3. 第一次預約：填寫乘車聯絡資料",
      "description": "第一次預約時需填寫真實姓名（必填，2 至 60 字）、單位與職稱（選填）、行動電話（選填，僅供接駁異動與現場緊急聯絡），並勾選確認為真實姓名。現場驗票人員只會看到姓名、單位與職稱；行動電話加密儲存，只有活動 owner 能在緊急聯絡情境查看，每次查看都有紀錄；資料於活動結束後 30 天自動刪除。儲存後會自動完成這次預約，同一活動不會再問。"
    },
    {
      "title": "4. 加入同行者（選填）",
      "description": "按「同行者一起預約」，最多可加 3 位同行者，連同本人一次最多 4 席。每位同行者要填真實姓名，各自有自己的乘車 QR、可單獨取消，也各自適用候補。同行者的單位、職稱與電話不會沿用您的資料。"
    },
    {
      "title": "5. 確認結果並取得 QR",
      "description": "預約成功後該班次會顯示「已預約」與「已預約座位成功」。額滿的班次會顯示「已加入候補，第 N 位」，有人取消時依序自動遞補並以 Email 通知。免登入預約請到信箱 30 分鐘內開啟確認連結（連結只能使用一次），開啟後即建立預約並同時登入。前往「我的接駁車」可看到登機證式卡片與乘車 QR；上車時向工作人員出示，請勿轉傳。候補沒有 QR。"
    },
    {
      "title": "6. 取消、行事曆與提醒",
      "description": "在時刻表或「我的接駁車」按「取消預約」並確認即可；預約與取消於發車前 12 小時截止，逾時請聯絡主辦單位。已確認的預約可按「加入行事曆」下載 .ics 檔（不含 QR）。想收提醒可在「我的接駁車」勾選「發車前 24 小時內寄 Email 提醒我」，預設關閉、隨時可關，提醒信不含乘車 QR。"
    }
  ],
  "afterward": [
    "同一人同一天同一方向最多一筆有效預約（確認或候補）",
    "活動頁頂端的「我的行程摘要」會顯示已預約與候補的趟數",
    "發車前 24 小時內，活動頁會出現「下一班車」卡片與 QR"
  ],
  "nextSteps": "預約失敗請見「無法預約活動接駁車」；餐飲與宴會回覆、客服請見「如何回覆餐飲宴會與使用客服」。",
  "faq": [
    {
      "q": "接駁車要錢嗎？",
      "a": "不用，接駁車免費。報名、付款與宴會資格一律以官方 TAAI 報名系統為準，本平台只提供補充服務資訊。"
    },
    {
      "q": "我可以幫別人預約嗎？",
      "a": "可以用「同行者」一起預約，最多 3 位，每位須填真實姓名；現場會用姓名核對。不可轉傳 QR。"
    },
    {
      "q": "額滿了還有機會嗎？",
      "a": "可以加入候補。有人取消時系統依序自動遞補第一位候補，並寄 Email 通知；候補順位會顯示在「我的接駁車」。"
    },
    {
      "q": "為什麼要我填真實姓名？",
      "a": "現場工作人員要以乘客名單核對上車者。系統無法驗證姓名真偽，只以您的明確確認與現場核對把關。"
    }
  ],
  "figures": [
    {
      "name": "shuttle-booking",
      "alt": "預約頁：選擇日期分頁與班次，每張班次卡顯示班次代碼、出發與到達站及座位狀態",
      "caption": "預約頁：選擇日期分頁與班次，每張班次卡顯示班次代碼、出發與到達站及座位狀態"
    },
    {
      "name": "my-shuttle",
      "alt": "我的接駁車：登機證式卡片、乘車 QR、加入行事曆、提醒與取消",
      "caption": "我的接駁車：登機證式卡片、乘車 QR、加入行事曆、提醒與取消"
    }
  ]
}
